const INSURER_PORTAL_ENTRIES: {
  name: string;
  url: string;
  anvaInsurerCodes?: string[];
}[] = [
  {
    name: 'AEGON Schadeverzekering N.V.',
    url: 'https://loginaip.aegon.nl/login',
    anvaInsurerCodes: ['A015', 'A215'],
  },
  {
    name: 'Allianz Benelux N.V.',
    url: 'https://allianzretailportal.com/',
    anvaInsurerCodes: ['P217', 'R221'],
  },
  {
    name: 'Allianz Global Assistance',
    url: 'https://allianzretailportal.com/',
    anvaInsurerCodes: ['E515'],
  },
  {
    name: 'Allianz Nederland Levensverz.',
    url: 'https://leven.allianz.nl/',
    anvaInsurerCodes: ['Z053'],
  },
  {
    name: 'ARAG SE',
    url: 'https://arag.my.site.com/s/login/?ec=302&startURL=%2Fs%2F',
    anvaInsurerCodes: ['A123', 'P207', 'V612'],
  },
  {
    name: 'ASR Schadeverzekering N.V',
    url: 'https://login.asrcockpit.nl/',
    anvaInsurerCodes: ['A059', 'A259'],
  },
  {
    name: 'ASR Schadeverzekering N.V.',
    url: 'https://login.asrcockpit.nl/',
    anvaInsurerCodes: ['P210', 'P231'],
  },
  {
    name: 'Avero Achmea Leven',
    url: 'https://www.averoachmea.nl/direct-regelen/inloggen',
    anvaInsurerCodes: ['L016'],
  },
  {
    name: 'Avero Achmea Schade',
    url: 'https://www.averoachmea.nl/direct-regelen/inloggen',
    anvaInsurerCodes: ['A080'],
  },
  {
    name: 'BLG Wonen',
    url: 'http://blgwonen.nl/voor-adviseurs.html',
    anvaInsurerCodes: ['B822'],
  },
  {
    name: 'Centraal Beheer Achmea',
    url: 'https://www.centraalbeheer.nl/voor-adviseurs/adviseursportaal',
    anvaInsurerCodes: ['C051'],
  },
  {
    name: 'Centraal Beheer Achmea Part. Nieuw',
    url: 'https://mijnportaal.centraalbeheerppi.nl/',
    anvaInsurerCodes: ['C004'],
  },
  {
    name: 'Credit Life',
    url: 'https://www.callas-extranet.nl/login.aspx?ReturnUrl=%2f',
    anvaInsurerCodes: ['C725'],
  },
  {
    name: 'DAS Ned Rechtsbijstand Verz N.V.',
    url: 'https://adviseur.das.nl/inloggen',
    anvaInsurerCodes: ['D203'],
  },
  {
    name: 'DAS Ned. Rechtsbijstand Verz.Mij NV',
    url: 'https://adviseur.das.nl/inloggen',
    anvaInsurerCodes: ['P205'],
  },
  {
    name: 'DAS Rechtsbijstand',
    url: 'https://adviseur.das.nl/inloggen',
    anvaInsurerCodes: ['D003'],
  },
  {
    name: 'DAS vestiging Zoetemeer',
    url: 'https://adviseur.das.nl/inloggen',
    anvaInsurerCodes: ['S344'],
  },
  {
    name: 'de Vereende N.V.',
    url: 'https://vereende.eu.auth0.com/login?state=g6Fo2SB4cTAtemhORC1YaF9wUmhoeXZON01CVHRvM0I1WUFjTKN0aWTZIEQtR2hoX2ZHaENvX0hsX0dRYU43U3Zjc0hJUTIzU3REo2NpZNkgb3d5b0lPZmlmdks1TzRlRWc1NXpIbnM3Y1Z4Wkx1bXI&client=owyoIOfifvK5O4eEg55zHns7cVxZLumr&protocol=oauth2&response_type=code&redirect_uri=https%3A%2F%2Fverzekeren.vereende.nl%2Fonze-vereende%2Flogin&scope=openid%20email&audience=https%3A%2F%2Fvereende.eu.auth0.com%2Fuserinfo&auth0Client=eyJuYW1lIjoiYXV0aDAuanMiLCJ2ZXJzaW9uIjoiOS4zLjMifQ%3D%3D',
    anvaInsurerCodes: ['T003'],
  },
  {
    name: 'De Zeeuwse Verzekeringen',
    url: 'https://www.dezeeuwse.nl/mijn-zeeuwse-adviseurs',
    anvaInsurerCodes: ['N019'],
  },
  {
    name: 'DELA Natura- en Levensverzekeringen',
    url: 'https://www.dela.nl/delaportaal',
    anvaInsurerCodes: ['D007'],
  },
  {
    name: 'Goudse Schadeverzekeringen N.V.',
    url: 'https://www.goudse.nl/mijn-goudse-adviseurs/dashboard',
    anvaInsurerCodes: ['G027'],
  },
  {
    name: 'Goudse Schadeverzekeringen NV',
    url: 'https://www.goudse.nl/mijn-goudse-adviseurs/dashboard',
    anvaInsurerCodes: ['N217', 'P221'],
  },
  {
    name: 'Hienfeld B.V.',
    url: 'https://portal.hienfeld.nl/login',
    anvaInsurerCodes: ['H749'],
  },
  {
    name: 'Klaverblad Schadeverzekeringsmij.',
    url: 'https://inloggen-extranet.klaverblad.nl/login',
    anvaInsurerCodes: ['K011'],
  },
  {
    name: 'Lifetri',
    url: 'https://lifetri.nl/zakelijk/intermediair/',
    anvaInsurerCodes: ['L030'],
  },
  {
    name: 'Mandaat Assuradeuren',
    url: 'https://mijn.mandaatassuradeuren.nl/Portal_Common/Login',
    anvaInsurerCodes: ['M712'],
  },
  {
    name: 'Monuta',
    url: 'https://www.monuta.nl/mijnmonuta/',
    anvaInsurerCodes: ['N002'],
  },
  {
    name: 'Monuta Verzekeringen N.V.',
    url: 'https://www.monuta.nl/mijnmonuta/',
    anvaInsurerCodes: ['V609', 'V610'],
  },
  {
    name: 'Movir',
    url: 'https://www.mijnmovir.nl/Customer_Auth/Login',
    anvaInsurerCodes: ['M041'],
  },
  {
    name: 'MS Amlin Insurance S.E. (tbv VPI)',
    url: 'https://www.msportaal.nl/login',
    anvaInsurerCodes: ['A549'],
  },
  {
    name: 'Nationale Nederlanden Schade Beurs',
    url: 'https://expo.nn.nl/p/login',
    anvaInsurerCodes: ['N010'],
  },
  {
    name: 'Nationale Nederlanden Schade Mij NV',
    url: 'https://adviseur.nn.nl/Welkom.htm?orgUrl=%2Fvp%2F',
    anvaInsurerCodes: ['N013', 'P216'],
  },
  {
    name: 'Nedasco B.V. Assuradeuren',
    url: 'https://www.nsn.nl/dashboard?category=mijn_administratie',
    anvaInsurerCodes: ['N705'],
  },
  {
    name: 'Noorderlinge Verzekeraars',
    url: 'https://noorderlinge.nl/login/?redirect_to=%2Fnoorderlink%2F',
    anvaInsurerCodes: ['K815'],
  },
  {
    name: 'O.O.M. Verzekeringen',
    url: 'https://www.oomverzekeringen.nl/tussenpersonenportaal/#/dashboard',
    anvaInsurerCodes: ['A017'],
  },
  {
    name: 'Onderlinge Nederland',
    url: 'https://connect.onderlinge.info/',
    anvaInsurerCodes: ['G029'],
  },
  {
    name: 'ONVZ Ziektekostenverzekeraar',
    url: 'https://login.onvz.nl/broker/select/authn',
    anvaInsurerCodes: ['O037'],
  },
  {
    name: 'REAAL Schadeverzekeringen N.V.',
    url: 'https://login.reaal.nl/algemeen/inloggenklant',
    anvaInsurerCodes: ['A137'],
  },
  {
    name: 'SAA Assuradeuren B.V.',
    url: 'https://extranet-login.saa.nl/',
    anvaInsurerCodes: ['K781'],
  },
  {
    name: 'Scildon N.V.',
    url: 'https://www.scildon.nl/adviseur/inloggen-voor-adviseurs',
    anvaInsurerCodes: ['L009'],
  },
  {
    name: 'Stad Holland Zorgverzekeraar',
    url: 'https://mijn.stadholland.nl/',
    anvaInsurerCodes: ['S042'],
  },
  {
    name: 'Stater Nederland B.V',
    url: 'https://e-adviseur.e-servicing.com/',
    anvaInsurerCodes: ['S901'],
  },
  {
    name: 'TAF B.V.',
    url: 'https://tp-portaal.taf.nl/',
    anvaInsurerCodes: ['T742'],
  },
  {
    name: 'Turien & Co. Assuradeuren B.V.',
    url: 'https://signicat.mijnturien.nl/broker/select/authn',
    anvaInsurerCodes: ['T741'],
  },
  {
    name: 'TVM verzekeringen',
    url: 'https://www.tvm.nl/inloggen-mijn-tvm',
    anvaInsurerCodes: ['T009'],
  },
  {
    name: 'Unigarant N.V.',
    url: 'https://www.salesgarant.nl/informatie/login?redirectUrl=%2Finformatie%2Fsecure%2Fbeheer%2F',
    anvaInsurerCodes: ['U705'],
  },
  {
    name: 'Voogd & Voogd',
    url: 'https://login.voogd.com/',
    anvaInsurerCodes: ['V755'],
  },
  {
    name: 'Zevenwouden',
    url: 'https://zevenwouden.nl/login/',
    anvaInsurerCodes: ['A019', 'A219'],
  },
  {
    name: 'Zevenwouden U.A.',
    url: 'https://zevenwouden.nl/login/',
    anvaInsurerCodes: ['P238'],
  },
  {
    name: 'Zwitserleven',
    url: 'https://www.zwitserleven.nl/mijnzwitserleven/adviseur/start/',
    anvaInsurerCodes: ['Z505'],
  },
  {
    name: 'Zwitserleven Hypotheken',
    url: 'https://www.zwitserleven.nl/mijnzwitserleven/adviseur/start/',
    anvaInsurerCodes: ['Z750'],
  },
];

export default INSURER_PORTAL_ENTRIES;
